/* ==========================================================
   TEASCATO — Product Page & Cart JavaScript (FINAL FIX)
   ========================================================== */

(function () {
  'use strict';

  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ── HEADER ── */
  function initHeader() {
    const header = qs('#site-header');
    if (!header) return;

    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });

    const btn = qs('.site-header__hamburger');
    const nav = qs('.site-header__mobile-nav');

    if (!btn || !nav) return;

    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('open', !open);
    });
  }

  /* ── CART COUNT ── */
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await res.json();

      qsa('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch (_) {}
  }

  /* ── PRODUCT PAGE ── */
function initProductPage() {
  const atcBtn = document.querySelector('#AddToCartBtn');
  const mainBtn = document.querySelector('#mainPriceUpdatee');
  if (!atcBtn) return;
  if (!mainBtn) return;
  const selectedInput = document.querySelector('#SelectedVariantId');
  const qtyInput      = document.querySelector('#ProductQuantity');
  const mainImg       = document.querySelector('#ProductMainImage');

  // Track unit price in cents so we can multiply by qty
  let unitPriceCents = (() => {
    const active = document.querySelector('.variant-btn.active');
    return active ? parseInt(active.getAttribute('data-price-cents') || '0', 10) : 0;
  })();

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00');
  }

  function updateAtcPrice() {
    const qty = parseInt(qtyInput?.value || '1', 10);
    const total = unitPriceCents * qty;
    if (atcBtn && !atcBtn.disabled) {
      atcBtn.textContent = `Add to Cart — ${formatMoney(total)}`;
    }
  }
   function updateAtcvPrice() {
    const qty = parseInt(qtyInput?.value || '1', 10);
    const total = unitPriceCents * qty;
    if (mainBtn && !mainBtn.disabled) {
      mainBtn.textContent = `${formatMoney(total)}`;
    }
  }

  /* =========================
     ✅ GLOBAL CLICK HANDLER
  ========================= */
  document.addEventListener('click', async (e) => {

    /* ---------- QTY ---------- */
    if (e.target.closest('#QtyMinus')) {
      let v = parseInt(qtyInput?.value || '1', 10);
      qtyInput.value = Math.max(1, v - 1);
      updateAtcPrice();
       updateAtcvPrice();
    }

    if (e.target.closest('#QtyPlus')) {
      let v = parseInt(qtyInput?.value || '1', 10);
      qtyInput.value = Math.min(99, v + 1);
      updateAtcPrice();
      updateAtcvPrice();
      
    }

    /* ---------- VARIANTS ---------- */
    const variantBtn = e.target.closest('.variant-btn');
    if (variantBtn) {

      if (variantBtn.disabled) return;

      document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      variantBtn.classList.add('active');

      const variantId   = variantBtn.getAttribute('data-variant-id');
      const available   = variantBtn.getAttribute('data-available') === 'true';
      const priceCents  = parseInt(variantBtn.getAttribute('data-price-cents') || '0', 10);

      if (selectedInput) selectedInput.value = variantId;
      unitPriceCents = priceCents;

      atcBtn.disabled = !available;
      if (available) {
        updateAtcPrice();
        updateAtcvPrice();
      } else {
        atcBtn.textContent = 'Sold Out';
      }
    }

    /* ---------- THUMBNAILS ---------- */
    const thumb = e.target.closest('.product-media__thumb');
    if (thumb) {
      const newSrc = thumb.getAttribute('data-src');
      if (!newSrc || !mainImg) return;

      document.querySelectorAll('.product-media__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      mainImg.src = newSrc;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
    }

    /* ---------- ADD TO CART ---------- */
    if (e.target.closest('#AddToCartBtn')) {
      e.preventDefault();

      const variantId = selectedInput?.value;
      const qty = parseInt(qtyInput?.value || '1', 10);

      if (!variantId) {
        window.location.href = '/cart';
        return;
      }

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: qty
          })
        });

        if (!res.ok) throw new Error('Add failed');

        await fetch('/cart.js', { cache: 'no-store' });

        window.location.href = '/cart';

      } catch (err) {
        console.warn(err);
        atcBtn.disabled = false;
        atcBtn.textContent = 'Try Again';
      }
    }

    /* ---------- BUY IT NOW ---------- */
    if (e.target.closest('#BuyNowBtn')) {
      e.preventDefault();

      const variantId = selectedInput?.value;
      const qty = parseInt(qtyInput?.value || '1', 10);
      if (!variantId) return;

      const buyBtn = document.querySelector('#BuyNowBtn');
      if (buyBtn) {
        buyBtn.textContent = 'Processing...';
        buyBtn.style.pointerEvents = 'none';
      }

      try {
        // Add item to cart, then go straight to checkout
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty })
        });
        if (!res.ok) throw new Error('Add failed');
        window.location.href = '/checkout';
      } catch (err) {
        console.warn('[Teascato] Buy Now error:', err);
        window.location.href = '/checkout';
      }
    }

  });
}

  /* ── CART PAGE FIX ── */
  async function fixCartPage() {
    if (window.location.pathname !== '/cart') return;

    try {
      const cartRes = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await cartRes.json();

      const hasItemsInDOM = qs('.cart-item');

      // ✅ If Shopify returned items but DOM is empty → reload ONCE
      if (cart.items.length > 0 && !hasItemsInDOM) {
        if (!sessionStorage.getItem('cart_fix_applied')) {
          sessionStorage.setItem('cart_fix_applied', '1');
          window.location.reload();
        }
      } else {
        sessionStorage.removeItem('cart_fix_applied');
      }

    } catch (err) {
      console.warn('[Teascato] Cart fix error:', err);
    }
  }

  /* ── CART PAGE EVENTS ── */
  function initCartPage() {
    const cartItems = qs('#CartItems');
    if (!cartItems) return;

    // Qty +/- buttons
    cartItems.addEventListener('click', async (e) => {
      const btn = e.target.closest('.cart-qty-btn');
      if (!btn) return;

      const key = btn.dataset.key;
      const action = btn.dataset.action;
      const row = btn.closest('.cart-item');
      const input = row?.querySelector('.cart-qty-input');

      if (!input) return;

      let newQty = parseInt(input.value, 10);
      if (action === 'minus') newQty = Math.max(0, newQty - 1);
      if (action === 'plus')  newQty = Math.min(99, newQty + 1);

      await updateCartLine(key, newQty);
    });

    // Remove buttons
    cartItems.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-remove]');
      if (!btn) return;

      const key = btn.dataset.key;
      if (!key) return;

      btn.textContent = 'Removing...';
      btn.style.pointerEvents = 'none';

      await updateCartLine(key, 0);
    });

    // Direct qty input change
    cartItems.addEventListener('change', async (e) => {
      const input = e.target.closest('.cart-qty-input');
      if (!input) return;
      const key = input.dataset.key;
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      await updateCartLine(key, qty);
    });
  }

  async function updateCartLine(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });

      window.location.reload();

    } catch (_) {
      window.location.reload();
    }
  }

  /* ── AGE GATE ── */
  function initAgeGate() {
    const gate = qs('#ageGate');
    if (!gate) return;

    if (sessionStorage.getItem('teascato_age_ok')) {
      gate.remove();
      return;
    }

    document.body.style.overflow = 'hidden';

    qs('#age-gate-yes')?.addEventListener('click', () => {
      sessionStorage.setItem('teascato_age_ok', '1');
      gate.remove();
      document.body.style.overflow = '';
    });

    qs('#age-gate-no')?.addEventListener('click', () => {
      window.location.href = 'https://www.responsibility.org/';
    });
  }

  /* ── INIT ── */
 function initAll() {
  initHeader();
  initAgeGate();
  initProductPage();
  initCartPage();
  updateCartCount();
  fixCartPage && fixCartPage();
}

document.addEventListener('DOMContentLoaded', initAll);
document.addEventListener('shopify:section:load', initAll);

})();